import { IDataEventsManager } from "OW.Remoting/Remoting/IDataEventsManager";
import { EventHelper } from "../../UI.BaseControls/Helpers/EventHelper";
import { IHTMLElementWithControl } from "../UI/Controls/ControlInterfaces";
import { IContentBuilder } from "../UI/DataBuilders/IContentBuilder";
import { FormManager } from "../UI/FormManager/IFormManager";
import { FormSizeComparer } from "../UI/FormSizeComparer";
import { MessageWindow } from "../UI/MessageWindow";
import { IMainMenuFactory, MessageButtonResult, UIHistoryState, UIHistoryStateForm, UIHistoryStateFrame } from "../UI/UIManager";
import { UIManagerWorker } from "../UI/UIManagerWorker";
import { IForm } from "../UI/XGControls/IForm";

export class DefUIManagerWorker extends UIManagerWorker {
    //pokud je true, zobrazi se overlay, pokud je false, zobrazi se loader
    private _overlayShown: boolean;
    private _blockingLayer: HTMLElement;
    private _menuOverlay: HTMLElement;
    private _menuOverlayVisible: boolean = false;

    private get _spinnerElement(): HTMLElement {
        return this.loader.getElementsByTagName("div")[0] as HTMLElement;
    }

    public override get blockingLayer(): HTMLElement {
        return this._blockingLayer;
    }

    public override showBlockingLayer(content?: IContentBuilder): void {
        if (this._blockingLayer == undefined) {
            this._blockingLayer = document.getElementById("blockingLayer");
            if (this._blockingLayer)
                this._blockingLayer.tabIndex = -1; //potřeba kvůli tomu, aby případný keyup nad overlayem měl v eventě target element, jinak by tam byl document
        }

        if (this._blockingLayer == null)
            return;
        this._blockingLayer.style.visibility = "visible";

        if (content)
            content.build().then((data) => {
                this._blockingLayer.appendChild(data);
            });
    }

    public override hideBlockingLayer(): void {
        if (this._blockingLayer == undefined) {
            this._blockingLayer = document.getElementById("blockingLayer");
        }

        if (this._blockingLayer == null)
            return;

        this._blockingLayer.style.visibility = "hidden";
        this._blockingLayer.innerHTML = "";
    }

    constructor(formsPlace: HTMLElement, private loader: HTMLElement, preloadFormCount: number = 0,
        mainMenuFactory: IMainMenuFactory, dataEventsManager: IDataEventsManager) {
        super(preloadFormCount, mainMenuFactory, dataEventsManager);

        //if (window.parent != null && window.parent.document.getElementById("loader") != null)
        //  this.loader = window.parent.document.getElementById("loader");

        this._overlayShown = false;

        this.addUIHistory({ type: "Menu" }, "Menu");

        if (formsPlace && Array.from(formsPlace.children).some(child => child.matches(":not(.hidden-formsplace-element)"))) { // jestli uz existuje definice formulare (login dialog), tak se zmeri a přerovná jeho velikost
            FormSizeComparer.setResizeListeners(formsPlace, true, this.windowResized);
        }
    }

    public override showMessage(msgWin: MessageWindow): Promise<MessageButtonResult> {
        return msgWin.show();
    }

    /**
     * @param formsPlaceOnly defaultne false, pokud je true, tak overlay zabere pouze plochu aplikace (ne menu)
     */
    public override actualizeOverlay(visible: boolean, formsPlaceOnly: boolean = false): void {
        this._overlayShown = visible;
        if (visible) {
            if (this.loader) {
                this.loader.style.visibility = "visible";
                this.loader.style.zIndex = "100";
                this._spinnerElement.style.display = "none";
                if (formsPlaceOnly) //this.Container.style.left = document.getElementById("formsMenu").clientWidth + "px";
                    this.loader.style.left = document.getElementById("formsMenu").clientWidth + "px";
            }
        } else {
            if (this.loader) {
                this.loader.style.visibility = "hidden";
                this.loader.style.removeProperty("z-index");
                //this._spinnerElement.style.visibility = "visible";
            }
        }
    }

    /**
     * Aktualizuje zobrazení loaderu
     * @param visible Jestli má být zobrazen overlay
     * @param actualizeSpinner Jestli má být zobrazen  spinner
     */
    public override actualizeLoader(visible: boolean, actualizeSpinner: boolean = true): void {
        if (!this._overlayShown) {
            this.loader.style.visibility = visible ? "visible" : "hidden";
            if (actualizeSpinner)
                this._spinnerElement.style.display = visible ? "block" : "none";
        }
    }

    public override loadUIHistoryState(state: UIHistoryState): void {
        if (state.type === "Menu") {
            FormManager.instance.closeForm(FormManager.instance.lastActiveForm.openedFormInfo.formInstanceId);

            const formsMenu = document.getElementById("formsMenu");
            if (formsMenu != null)
                formsMenu.classList.remove("hidden");
        } else if (state.type === "Form") {
            const formState = state as UIHistoryStateForm;
            FormManager.instance.openForm(formState.formName);
        } else if (state.type === "Frame") {
            const frameState = state as UIHistoryStateFrame;
            const formHtmlElement = document.querySelector("#formsPlace .Form") as IHTMLElementWithControl;
            if (formHtmlElement.id == frameState.formID) {
                const form = formHtmlElement.tscControl as IForm;
                form.setVisibleFrame(frameState.frameName, false);
            }
        }
    }

    /**
     * Zobrazí menu overlay, pokud ještě není zobrazený.
     */
    public override showMenuOverlay(): void {
        if (!this._menuOverlay) {
            this._menuOverlay = document.createElement("div");
            this._menuOverlay.setAttribute("id", "menu-overlay");
            this._menuOverlay.onclick = (e) => {
                this.menuOverlayClicked.trigger(this, e);
                EventHelper.stopPropagation(e);
            };
        }
        if (!this._menuOverlayVisible) {
            this._menuOverlayVisible = true;
            const appContent = document.getElementById("appContent");
            appContent.appendChild(this._menuOverlay);
        }
    }

    /**
     * Skryje menu overlay pokud byl zobrazený.
     */
    public override hideMenuOverlay(): void {
        if (this._menuOverlayVisible && this._menuOverlay) {
            this._menuOverlayVisible = false;
            this._menuOverlay.remove();
        }
    }
}
